module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.addtotrolley', {
            url: '/addtotrolley?{stockcode}&{quantity:int}&{source}',
            onEnter: [
                'ShelfProductService', '$stateParams', '$state', function (shelfProductService, $stateParams, $state) {
                    if ($stateParams.stockcode && $stateParams.quantity) {
                        shelfProductService.addItemToTrolley($stateParams.stockcode, $stateParams.quantity, $stateParams.source)
                            .then(() => $state.go('root'));
                    } else {
                        $state.go('root');
                    }
                },
            ],
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/addtotrolley.js